import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { isTooManyEmailVerificationRequestsError } from '../../util/errors';
import { NamedLink } from '../../components';

import css from './ModalMissingInformation.module.css';

const EmailReminder = props => {
  const {
    user,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    onResendVerificationEmail,
  } = props;

  const email = user.id ? user.attributes.email : '';

  const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
    sendVerificationEmailError
  )
    ? 'ModalMissingInformation.resendFailedTooManyRequests'
    : 'ModalMissingInformation.resendFailed';

  const resendErrorMessage = sendVerificationEmailError ? (
    <div className={css.error}>
      <FormattedMessage id={resendErrorTranslationId} />
    </div>
  ) : null;

  return (
    <div className={css.root}>
      <div className={css.rootBody}>
        <span className={css.badge}>
          <FormattedMessage id="ModalMissingInformation.emailVerificationBadge" />
        </span>

        <h2 className={css.title}>
          <FormattedMessage id="ModalMissingInformation.verifyEmailTitle" />
        </h2>

        <p className={css.text}>
          <FormattedMessage id="ModalMissingInformation.verifyEmailText" />
        </p>

        {email ? <div className={css.emailBox}>{email}</div> : null}

        {resendErrorMessage}

        <button
          type="button"
          className={css.cta}
          onClick={onResendVerificationEmail}
          disabled={sendVerificationEmailInProgress}
        >
          {sendVerificationEmailInProgress ? (
            <FormattedMessage id="ModalMissingInformation.sendingEmail" />
          ) : (
            <FormattedMessage id="ModalMissingInformation.resendEmailLinkText" />
          )}
        </button>

        <NamedLink className={css.secondaryLink} name="ContactDetailsPage">
          <FormattedMessage id="ModalMissingInformation.fixEmailLinkText" />
        </NamedLink>
      </div>
    </div>
  );
};

export default EmailReminder;
